/**
 * Intent/keyword lists from config JSON with fallback defaults.
 * Single source for plan/tournament/training/genericHelp (G1). No keyword constants in callers.
 * Defaults live only here; callers (flow.intent.js, ai-chat-panel.jsx) use this loader only.
 */

import intentKeywordsConfig from "./intent-keywords.config.json";

const DEFAULTS = {
  plan: ["plane", "plan", "planen", "erstellen", "anlegen", "starten"],
  tournament: ["turnier", "schleifchen", "clubmeisterschaft", "meisterschaft", "wettkampf"],
  training: ["training", "stunde", "stunden", "trainerstunde"],
  genericHelp: ["hilfe", "help", "was kannst", "optionen", "wie geht", "was ist", "start", "was kann"],
};

function ensureStringArray(value, fallback) {
  if (Array.isArray(value) && value.every((v) => typeof v === "string")) {
    return value;
  }
  return Array.isArray(fallback) ? fallback : [];
}

const config = intentKeywordsConfig || {};
/** Plan-intent keywords (config-first, fallback in this loader only). */
export const PLAN = ensureStringArray(config.plan, DEFAULTS.plan);
/** Tournament-intent keywords. */
export const TOURNAMENT = ensureStringArray(config.tournament, DEFAULTS.tournament);
/** Training-intent keywords. */
export const TRAINING = ensureStringArray(config.training, DEFAULTS.training);
/** Generic help / short-query keywords. */
export const GENERIC_HELP = ensureStringArray(config.genericHelp, DEFAULTS.genericHelp);
